import { Route } from '@angular/router';
import { LoginGuard, PermissionGuard } from '@simac/ui';

export const LoggingRoute: Route = {
  path: 'logging',
  children: [
    {
      path: '',
      loadComponent: () => import('./pages/logging.component').then((m) => m.LoggingComponent),
    },
    {
      path: ':flowType/:groupId',
      loadComponent: () => import('./pages/operation.component').then((m) => m.OperationComponent),
    },
  ],
  canActivate: [LoginGuard, PermissionGuard],
};
